import { styled } from '@mui/material/styles';

import { OutlinedIconContainer } from 'components/UIkit/atoms/Button';

export const QuickActionContainer = styled(OutlinedIconContainer)`
  min-width: unset;
  padding: 8px;
  box-shadow: none;
  margin-right: 8px;

  svg {
    margin: 0;
    width: 16px;
    height: 16px;
  }
`;
